<script>
  import Container from '@/Elements/Containers/FullCentred.svelte';
  import Meta from '@/Elements/Signals/Dark/Meta/XSmall.svelte';
  import Title from '@/Elements/Signals/Dark/Title.svelte';
  import Para from '@/Elements/Signals/Dark/Para.svelte';
  import List from '@/Elements/Lists/Basic.svelte';
  import Card from '@/Elements/Shapes/Cards/Basic.svelte';
  import Link from '@/Elements/Actions/Links/Subtle.svelte';

  export let pitch;

  let meta = pitch.meta;
  let title = pitch.title;
  let text = pitch.text;
  let items = pitch.items;
  let action = pitch.action;
</script>

<style></style>

<section id="consultation" class="pt-24 pb-12 bg-gradient-to-b from-gray-100 via-gray-50 to-white">
  <Container>
    <div class="flex flex-col text-center items-center">
      <div class="flex flex-col space-y-3 px-var py-6">
        <div class="space-y-1">
          <Meta>{meta}</Meta>
          <Title>{title}</Title>
        </div>
        <Para>{text}</Para>
      </div>
      <div class="px-var pt-12">
        <List>
          {#each items as item}
            <Card {item}></Card>
          {/each}
        </List>
      </div>
      <div class="flex justify-center text-center">
        <div class="max-w-sm pt-24">
          <Link item={action}>{action.text}</Link>
        </div>
      </div>
    </div>
  </Container>
</section>